//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseContent(content: any): any {
  if (typeof content === 'string') {
    return JSON.parse(content);
  }

  return content;
}
